import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "table" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", { scope: "col" }, null, -1)
const _hoisted_6 = { class: "d-flex justify-content-center align-items-center w-100 h-100" }
const _hoisted_7 = { scope: "row" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center w-100 h-100"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-lg fs-6" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { scope: "row" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "d-flex justify-content-center align-items-center w-100 h-100" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 3,
  class: "h-10-em d-flex align-items-center justify-content-center"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, null, -1)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckBox = _resolveComponent("CheckBox")!

  return (_ctx.info !== _ctx.loadingPlaceholder && _ctx.info.selectedItems.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('review.upload.page.reviewMatrix', { node : _ctx.$s(_ctx.info.node.name) })), 1),
        (!_ctx.info.hasNextNodeWithPositions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$t('review.upload.matrix.noNodeWithPositionsButAttachedPostions')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.info.attachedParticipationInfos.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$t('review.upload.matrix.attachedHint')), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_5,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.realms, (realm) => {
                return (_openBlock(), _createElementBlock("th", {
                  scope: "col",
                  key: realm.id,
                  class: "align-middle"
                }, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$s(realm.code)) + " " + _toDisplayString(_ctx.$s(realm.name)), 1)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.participations, (participationInfo) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: participationInfo.participation.id
              }, [
                _createElementVNode("th", _hoisted_7, [
                  _createTextVNode(_toDisplayString(participationInfo.organisation.name) + " ", 1),
                  (participationInfo.mainParticipant != null)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_8, " (" + _toDisplayString(participationInfo.mainParticipant.surName) + " " + _toDisplayString(participationInfo.mainParticipant.givenName) + ") ", 1))
                    : _createCommentVNode("", true)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.realms, (realm) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: [participationInfo.participation.id, realm.id],
                    class: "align-middle"
                  }, [
                    (_ctx.selectedMap.get(realm.id)?.get(participationInfo.participation.id) === true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.attachedParticipationInfos, (participationInfo) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: participationInfo.participation.id
              }, [
                _createElementVNode("th", _hoisted_12, [
                  _createTextVNode(_toDisplayString(participationInfo.organisation.name) + " ", 1),
                  (participationInfo.mainParticipant != null)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_13, " (" + _toDisplayString(participationInfo.mainParticipant.surName) + " " + _toDisplayString(participationInfo.mainParticipant.givenName) + ") ", 1))
                    : _createCommentVNode("", true)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.realms, (realm) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: [participationInfo.participation.id, realm.id],
                    class: "align-middle"
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_CheckBox, {
                        mode: "flex",
                        disabled: this.disabled,
                        title: _ctx.$s(realm.code) + ' ' + _ctx.$s(realm.name),
                        "onUpdate:modelValue": (checked) => 
                                             this.setSelected(realm.id,participationInfo.participation.id, checked)
                      }, null, 8, ["disabled", "title", "onUpdate:modelValue"])
                    ])
                  ]))
                }), 128))
              ]))
            }), 128))
          ])
        ])
      ]))
    : (_ctx.info !== _ctx.loadingPlaceholder && _ctx.info.selectedItems.length <= 0)
      ? (_openBlock(), _createElementBlock("b", _hoisted_15, _toDisplayString(_ctx.$t('review.upload.matrix.noNodeWithPositions')), 1))
      : (_ctx.error != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createTextVNode(_toDisplayString(_ctx.$t('review.upload.matrix.error')) + " ", 1),
            _createElementVNode("button", {
              disabled: this.disabled,
              type: "button",
              class: "btn btn-outline-secondary btn-sm ms-3",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.retry()))
            }, _toDisplayString(_ctx.$t('general.retry')), 9, _hoisted_17)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
}